<template lang="html">
  <div class="columns" style="min-width:1364px;">
    <div class="column" style="width: 490px; margin-top: 6em; flex-grow: 0; padding-left:15px;">
      <ReviewListFilterFlow @toggle-pad="togglePad" @select-page="selectedPage"/>
    </div>
    <div class="column flow-detail"
         style="padding-bottom:0px; margin-top: 5em;"
         :class="{'flow-detail-with-pad': togglePad}">
      <FlowDetail
          :uid="$store.selected_review_uid"
          v-if="$store.state.selected_review_uid != null"
          :showPad="showPad"
          :selectPadPage="selectPage"
      />
      <div v-else class="has-text-centered has-text-grey" style="margin-top: 5em;">
        <div class="box" style="background-color: #f5f5f5; border: none;">
          <p class="is-size-5">Veuillez cliquer sur un élément de la liste pour voir les détails.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewListFilterFlow from '@/components/ReviewListFilterFlow.vue';
import FlowDetail from '@/components/FlowDetail.vue';

export default {
  name: 'flow',
  components: {
    ReviewListFilterFlow,
    FlowDetail
  },
  data() {
    return {
      showPad: false,
      selectPage: 'pad'
    };
  },
  methods: {
    togglePad(newShowPad) {
      this.showPad = newShowPad;
    },
    selectedPage(page) {
      this.selectPage = page;
    }
  }
};
</script>


<style scoped>
.card {
  border-radius: 0.25rem;
}

.flow-detail {
  max-height: calc(100vh - 90px);
}

.flow-detail-with-pad {

}
</style>
